import { useEffect, useState } from 'react';
import './HeroContent.scss';
import { motion } from 'framer-motion';

const HeroContent = () => {
  const [text, setText] = useState('');
  const fullText = 'Building Materials & Real Estate';

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      if (i < fullText.length) {
        setText(fullText.slice(0, i + 1));
        i++;
      } else {
        clearInterval(interval);
      }
    }, 70);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="heroContent text-center text-black">
      <div className="container heroContainer">
        <motion.div
          className="headings"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <h2>One Powerful Solution for</h2>
          <h1>
            {text}
            {text.length < fullText.length && (
              <motion.span
                animate={{ x: [0, 2, 0] }}
                transition={{ repeat: Infinity, duration: 0.5 }}
                className="typing-icon"
              >
                |
              </motion.span>
            )}
          </h1>
        </motion.div>
        <p>
          Connect to verified suppliers, developers, and financing options. From
          cement bags to mega developments all in one trusted platform.
        </p>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <a href="register">
            <button className="heroBtn-filled heroBtn">
              Get Started for Free
            </button>
          </a>
          <button className="heroBtn-outline heroBtn">
            <a href="#platforms-section">Explore Platforms</a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroContent;